// extracted by mini-css-extract-plugin
var _1 = "Po4T1D4rsLsRp5Uqbb7x";
var _2 = "a3n3I3cHxN4CGLIDUvOZ";
var _3 = "gYrnuvwTp1do3Iou78MF";
export { _1 as "canvas", _2 as "root", _3 as "spinner" }
